// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionButton_button__cG5VZ { padding: 8px 12px; border-radius: 4px; background: #007bff; color: #fff; }`, "",{"version":3,"sources":["webpack://./src/modules/Manager/FinStatisticV2/components/ActionButton.module.css"],"names":[],"mappings":"AAAA,8BAAU,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE","sourcesContent":[".button { padding: 8px 12px; border-radius: 4px; background: #007bff; color: #fff; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ActionButton_button__cG5VZ`
};
export default ___CSS_LOADER_EXPORT___;
